<div class="col-12" *ngIf="progresso">
    <div class="row row-margin align-items-center">
        <img src="./assets/icons/arrow.svg">
        <span class="section-title ml-2">Acesso Rápido</span>
    </div>  
<!--    <div (click)="novoPedido()" class="row mt-4 acesso-rapido" [tourAnchor]="'4'">-->
<!--        <div class="align-center">-->
<!--            <img src="./assets/icons/acesso-rapido/pedido.svg">-->
<!--            <span class="acesso-title ml-3">Novo Pedido</span>-->
<!--        </div>-->
<!--        <img src="./assets/icons/acesso-rapido/arrow.svg">-->
<!--    </div>-->
<!--    <div (click)="novoColaborador()" class="row acesso-rapido" [tourAnchor]="'3'">-->
<!--        <div class="align-center">-->
<!--            <img src="./assets/icons/acesso-rapido/colaborador.svg">-->
<!--            <span class="acesso-title ml-3">Cadastrar Colaborador</span>-->
<!--        </div>-->
<!--        <img src="./assets/icons/acesso-rapido/arrow.svg">-->
<!--    </div>-->
<!--    <div (click)="novoBeneficio()" class="row acesso-rapido" [tourAnchor]="'2'">-->
<!--        <div class="align-center">-->
<!--            <img src="./assets/icons/acesso-rapido/beneficio.svg">-->
<!--            <span class="acesso-title ml-3">Aderir Incentivo</span>-->
<!--        </div>-->
<!--        <img src="./assets/icons/acesso-rapido/arrow.svg">-->
<!--    </div>-->
    <div *ngFor="let btn of btnAcessoRapido | slice:0 : this.progresso.progresso === 100 ? 4 : 3; let i = index" (click)="actionRouter(btn.action)" class="row acesso-rapido" [tourAnchor]="btn.tourAnchor" [ngStyle]="{'border-radius': i == 0 ? '5px 5px 0 0' : i == btnAcessoRapido.length -1 ? '0 0 5px 5px' : '0'}">
        <div class="align-center">
            <img [src]="btn.imgSrc" [alt]="btn.btnName">
            <span class="acesso-title ml-3">{{btn.btnName}}</span>
        </div>
        <img src="./assets/icons/acesso-rapido/arrow.svg" alt="Arrow">
    </div>
    <div class="row acesso-rapido-tutorial" *ngIf="progresso.progresso < 100" [hidden]="progresso?.progresso >= 100" [tourAnchor]="'1'">
        <div class="sphere row text-center font-progress-bar">
            <div class="col align-self-center p-0">{{progresso.progresso + '%'}}</div>
        </div>
        <div class="col p-0 align-self-center">
            <div class="progress">
                <div class="progress-bar" [style.width.%]="progresso.progresso" role="progressbar"
                     [attr.aria-valuenow]="progresso.progresso"
                     aria-valuemin="0"
                     aria-valuemax="100"></div>
            </div>
        </div>
    </div>


    <span *ngIf="progresso.progresso < 100" class="acesso-title" (click)="showModalFinalizar(finalizarTutorial)">Completar o tutorial</span>



</div>

<ng-template #finalizarTutorial let-modal>
    <div class="row px-4 text-center template template-finalizar-background">
        <div class = "col-12 title-modal-finalizar">
            <h3>Deseja mesmo finalizar o tutorial?</h3>

        </div>
        <div class="col-12 botoes-modal-finalizar">
            <button class="sim-modal-finalizar" (click)="terminarTutorial(); modal.dismiss()">Sim</button>
            <button class="nao-modal-finalizar" (click)="modal.dismiss()">Não</button>

        </div>
    </div>
</ng-template>